import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('CompanyIssueListController', CompanyIssueListController);

    /** @ngInject */
    function CompanyIssueListController(
        $interval,
        $scope,
        $state,
        $rootScope,
        ngDialog,
        CompanyFactory,
        CompaniesFactory,
        DownloadFileService,
        BulkModeService,
        LocalStorageService
    ) {
        var vm = this;
        var issuesInterval;

        init();

        // -----------------------
        // Bulk Mode related stuff
        // -----------------------

        BulkModeService.attachBulkModeFunctions(vm, 'issues', 'id');

        function enableBulkMode() {
            vm.enableBulkMode();
        }

        // Bulk Actions

        vm.bulkIssuePrintout = function () {
            if (!vm.batchIsEmpty()) {
                CompaniesFactory.downloadIssuePrintout(
                    vm.companyId,
                    vm.batchItems.join(',')
                ).then(downloadFile);
            }
        };

        vm.bulkJobPrintout = function () {
            if (!vm.batchIsEmpty()) {
                CompaniesFactory.downloadJobPrintout(
                    vm.companyId,
                    vm.batchItems.join(',')
                ).then(downloadFile);
            }
        };

        vm.bulkChangeStatus = function () {
            if (!vm.batchIsEmpty()) {
                ngDialog.open({
                    template: 'bulkChangeStatusDialog',
                    controller: 'BulkChangeStatusController',
                    controllerAs: 'BulkChangeStatusCtrl',
                    className: 'dialog-theme',
                    data: {
                        batchItems: vm.batchItems.join(','),
                        company: vm.companyId,
                    },
                });
            }
        };

        // EOT Bulk Mode

        /**
         * Delegates row click handling to appropriate handler depending
         * of the active mode.
         *
         * @param issueId
         */
        vm.handleRowClick = function (issueId) {
            showIssueDetails(issueId);
        };

        vm.changeOrdering = function (fieldName) {
            var newOrdering = vm.ordering.splice(0);
            var ascIndex = newOrdering.findIndex(i => i === fieldName);
            var descIndex = newOrdering.findIndex(i => i === `-${fieldName}`);

            if (descIndex > -1) {
                newOrdering = [];
            } else if (ascIndex > -1) {
                newOrdering = [`-${fieldName}`];
            } else {
                newOrdering = [fieldName];
            }
            vm.ordering = newOrdering;
        }

        vm.orderingIcon = function (fieldName) {
            var ascIndex = vm.ordering.findIndex(i => i === fieldName);
            var descIndex = vm.ordering.findIndex(i => i === `-${fieldName}`);

            if (descIndex > -1) {
                return "/assets/images/sort-desc-ico.png";
            } else if (ascIndex > -1) {
                return "/assets/images/sort-asc-ico.png";
            } else {
                return "";
            }
        }

        vm.clearRealizationDateFilter = function () {
            vm.realizationDateFrom = null;
            vm.realizationDateTo = null;
        }

        vm.clearCreationDateFilter = function () {
            vm.createdFrom = null;
            vm.createdTo = null;
        }

        function init() {
            vm.readIssuesService = function (companyId, params) {
                // If CompaniesFactory.readIssues is not wrapped in that way then
                // this.$http in CompaniesFactory is not defined when paginator
                // try to fetch data.
                return CompaniesFactory.readIssues(companyId, params);
            };
            vm.statusesList = [
                { name: 'Nowe', value: 'new' },
                { name: 'Przekazano', value: 'forwarded' },
                { name: 'Przyjęto', value: 'inprogress' },
                { name: 'Zduplikowano', value: 'duplicate' },
                { name: 'Częściowo zrealizowano', value: 'partlyfixed' },
            ];
            vm.areIssuesAvailable = true;
            vm.ordering = [];
            const setupFlexMenusStructure = () => {
                vm.flexMenusStructure = [
                    [
                        {
                            name: 'Pobierz widok',
                            func: downloadXLSFile,
                            if: true,
                        },
                        {
                            name: 'Grupowe zaznaczanie zgłoszeń',
                            func: enableBulkMode,
                            if: vm.isManager,
                        },
                    ],
                ];
            };
            vm.params = setParams();

            getCompany().then(setupFlexMenusStructure);

            setEmitter();
            setIssueInterval();

            onDestroy();
        }

        function onDestroy() {
            $scope.$on('$destroy', function () {
                removeIntervals();
            });
        }

        function setParams() {
            var params = {
                page_size: (function () {
                    if (vm.params) {
                        return vm.params.page_size || 50;
                    }
                })(),
                page: (function () {
                    if (vm.params) {
                        return vm.params.page || 1;
                    }
                })(),
                status: vm.status,
                active: true,
                search: vm.search,
                customer: (function () {
                    if (vm.housingAssociation) {
                        return vm.housingAssociation.party_uuid;
                    }
                })(),
                realization_date_from: vm.realizationDateFrom,
                realization_date_to: vm.realizationDateTo,
                date_from: vm.createdFrom,
                date_to: vm.createdTo,
                issue_category: vm.category,
                settlement: vm.settlement,
                assigned_to: vm.assignedTo,
                ordering: vm.ordering.join(","),
            };

            if (vm.customFieldFilters) {
                vm.customFieldFilters.forEach(function (customField) {
                    Object.assign(params, customField);
                });
            }

            return params;
        }

        function setWatcher() {
            $scope.$watchGroup(
                [
                    function () {
                        return vm.status;
                    },
                    function () {
                        return vm.search;
                    },
                    function () {
                        return vm.housingAssociation;
                    },
                    function () {
                        return vm.realizationDateFrom;
                    },
                    function () {
                        return vm.realizationDateTo;
                    },
                    function () {
                        return vm.createdFrom;
                    },
                    function () {
                        return vm.createdTo;
                    },
                    function () {
                        return vm.category;
                    },
                    function () {
                        return vm.settlement;
                    },
                    function () {
                        return vm.assignedTo;
                    },
                    function () {
                        return vm.customFieldFilters;
                    },
                    function() {
                        return vm.ordering;
                    }
                ],
                function () {
                    vm.params = setParams();
                    vm.params.page = 1;

                    getIssues();
                }
            );
        }

        function setEmitter() {
            $rootScope.$on('emitThisIssue', function (_, data) {
                vm.issues.results.forEach(function (issue, index) {
                    if (issue.issue_id === data.issue_id) {
                        if (
                            data.status === 'fixed' ||
                            data.status === 'rejected'
                        ) {
                            removeIssueFromTableAndUpdateList(index);

                            return;
                        }

                        data.address = data.locations[0].address;
                        vm.issues.results[index] = data;
                    }
                });
            });
        }

        function removeIssueFromTableAndUpdateList(issueIndex) {
            vm.issues.results.splice(issueIndex, 1);

            if (!vm.issues.results.length && vm.issues.page !== 1) {
                vm.params.page = 1;
                getIssues();
            }
        }

        function getCompany() {
            return CompanyFactory.readCompany().then(function (response) {
                LocalStorageService.saveObject('common/company', response.data);

                vm.isManager = response.data.manager;
                vm.companyId = response.data.organization.party_uuid;

                getHAs();
                setWatcher();

                CompaniesFactory.readCompanies(vm.companyId).then(
                    function (companySettings) {
                        if (companySettings.data.estimate_status) {
                            vm.statusesList.push({
                                name: 'Kosztorys',
                                value: 'estimate',
                            });
                        }
                        if (companySettings.data.invoiced_status) {
                            vm.statusesList.push({
                                name: 'Zrealizowano',
                                value: 'fixed',
                            });
                        }
                        vm.newUiIssueForm =
                            companySettings.data.new_ui_issue_form_enabled;
                    },
                );
            });
        }

        function getHAs() {
            CompaniesFactory.readHousingAssociations(vm.companyId, {
                page_size: 1000,
            }).then(function (housingResponse) {
                vm.haFromBackend = housingResponse.data.results;
            });
        }

        function getIssues() {
            CompaniesFactory.readIssues(vm.companyId, vm.params).then(
                function (response) {
                    vm.areIssuesAvailable = true;
                    vm.issues = response.data;
                },
                function (error) {
                    if (error.status === 404) {
                        vm.areIssuesAvailable = false;
                    }
                }
            );
        }

        function showIssueDetails(issueId) {
            $state.go('company_employee.issue_list.details', {
                issue_id: issueId,
            });
        }

        function downloadFile(httpFileResponse) {
            DownloadFileService.downloadFile(httpFileResponse);
        }

        function downloadXLSFile() {
            CompaniesFactory.downloadView(vm.companyId, vm.params).then(
                downloadFile
            );
        }

        function setIssueInterval() {
            issuesInterval = $interval(function () {
                getIssues();
            }, 60000);
        }

        function removeIntervals() {
            if (issuesInterval) {
                $interval.cancel(issuesInterval);
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/company_issue_list.controller.ts